import { p as promiseResolve, b as bootstrapLazy } from './index-4ed2a3e3.js';

/*
 Stencil Client Patch Esm v2.14.0 | MIT Licensed | https://stenciljs.com
 */
var patchEsm = function patchEsm() {
  return promiseResolve();
};
var defineCustomElements = function defineCustomElements(win, options) {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(function () {
    return bootstrapLazy([["deckgo-deck", [[1, "deckgo-deck", {
      "keyboard": [4],
      "embedded": [4],
      "cloneBackground": [4, "clone-background"],
      "reveal": [4],
      "revealOnMobile": [4, "reveal-on-mobile"],
      "animation": [513],
      "direction": [1537],
      "directionMobile": [513, "direction-mobile"],
      "autoSlide": [1, "auto-slide"],
      "autoSlideInterval": [2, "auto-slide-interval"],
      "rtl": [32],
      "activeIndex": [32],
      "dir": [32],
      "initSlideSize": [64],
      "toggleKeyboardAssist": [64],
      "getDeckDefinition": [64],
      "getSlideDefinition": [64],
      "loadBackground": [64],
      "loadHeader": [64],
      "loadFooter": [64],
      "isBeginning": [64],
      "isEnd": [64],
      "getActiveIndex": [64],
      "getLength": [64],
      "slideNext": [64],
      "slidePrev": [64],
      "slideTo": [64],
      "deleteActiveSlide": [64],
      "blockSlide": [64],
      "toggleFullScreen": [64],
      "doPrint": [64],
      "lazyLoadAllContent": [64]
    }, [[1, "mousedown", "mousedown"], [1, "touchstart", "touchstart"], [1, "mouseup", "mouseup"], [1, "touchend", "touchend"], [1, "mousemove", "mousemove"], [1, "touchmove", "touchmove"], [1, "dblclick", "dblclick"], [1, "contextmenu", "contextMenu"], [0, "scrolling", "scrolling"], [0, "keypress", "keypress"], [0, "slideDidLoad", "slideDidLoad"]]]]], ["deckgo-doc", [[1, "deckgo-doc", {
      "size": [513],
      "orientation": [513],
      "zoom": [2],
      "docSize": [32]
    }]]]], options);
  });
};
export { defineCustomElements };